import { render, staticRenderFns } from "./lTable.vue?vue&type=template&id=9820bcc6&"
import script from "./lTable.vue?vue&type=script&lang=js&"
export * from "./lTable.vue?vue&type=script&lang=js&"
import style0 from "./lTable.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports